import http from "@/plugins/http";

const api = {
  list: '/roles/list',
  add: '/roles/add',
  delete: '/roles/delete',
  update: '/roles/update',
  info: '/roles/info'
}

export default api

// 新
export function getRoleList (parameter) {
  return http({
    url: api.list,
    method: 'get',
    params: parameter
  })
}
export function roleAdd (parameter) {
  return http({
    url: api.add,
    method: 'post',
    data: parameter
  })
}
export function roleDelete (parameter) {
  return http({
    url: api.delete,
    method: 'get',
    params: parameter
  })
}

export function roleUpdate (parameter) {
  return http({
    url: api.update,
    method: 'post',
    data: parameter
  })
}

export function getRoleInfo (parameter) {
  return http({
    url: api.info,
    method: 'get',
    params: parameter
  })
}
